import SqFetch from 'application/fetch';
import { SALES_CART_NUMBER_PARAM } from 'constants/sales_cart';

export default class CartClient {
  constructor(orderNumber, storeCode, languageCode) {
    this.orderNumber = orderNumber;
    this.storeCode = storeCode;
    this.languageCode = languageCode;
  }

  _urlContext() {
    return `?store_code=${this.storeCode}&language_code=${this.languageCode}&order_number=${this.orderNumber}`;
  }

  promotionEligibility(...codes) {
    const queryParams = new URLSearchParams(
      codes.map((code) => ['codes[]', code]),
    );

    return SqFetch.get(
      `/shop/api/cart/promotion/eligibility?${queryParams}`,
    ).then((response) => (response.ok ? response.json() : null));
  }

  addPromotion(promoCode) {
    return SqFetch.post(
      `/shop/hardware/${this.storeCode}/${
        this.languageCode
      }/cart/promotion/${encodeURIComponent(promoCode)}`,
    )
      .then((response) => response.json())
      .then((data) =>
        data.success ? Promise.resolve() : Promise.reject(data),
      );
  }

  removePromotion(promoCode) {
    return SqFetch.post(
      `/shop/hardware/${this.storeCode}/${
        this.languageCode
      }/cart/promo/${encodeURIComponent(promoCode)}`,
      '_method=delete',
      {
        contentType: 'application/x-www-form-urlencoded',
      },
    ).then((response) =>
      response.ok ? Promise.resolve() : Promise.reject(response.statusText),
    );
  }

  updateQuantity(
    variantToken,
    quantity,
    addOnIds,
    action,
    salesCartNumber = null,
  ) {
    const payload = {
      store_code: this.storeCode,
      language_code: this.languageCode,
      update_cart_action: action,
      line_items_attributes: [
        {
          variant_token: variantToken,
          quantity,
          add_ons: addOnIds,
        },
      ],
    };

    // Only include sales_cart_number if it's provided. This cart can only be applied in our backend if the request is an internal request.
    if (salesCartNumber) {
      payload[SALES_CART_NUMBER_PARAM] = salesCartNumber;
    }

    return SqFetch.put('/shop/api/cart', payload);
  }

  shippingLogistics() {
    return SqFetch.get(
      `/shop/api/v1/cart/shipping_logistics${this._urlContext()}`,
    ).then((response) => (response.ok ? response.json() : null));
  }
}
